import { createContext, useContext, useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";
import AdminPage from "@/pages/AdminPage";

const LenisContext = createContext(null);
export const useLenis = () => useContext(LenisContext);

export function scrollToSection(lenis, id) {
    if (lenis) {
        lenis.scrollTo(`#${id}`, { offset: -72, duration: 1.5 });
    } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
}

function App() {
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <LenisContext.Provider value={lenisRef}>
            <div className="App bn-grain">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/terms" element={<LegalPage page="terms" />} />
                        <Route path="/privacy-policy" element={<LegalPage page="privacy" />} />
                        <Route path="/disclaimer" element={<LegalPage page="disclaimer" />} />
                        <Route path="/admin" element={<AdminPage />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="bottom-right" theme="dark" richColors />
            </div>
        </LenisContext.Provider>
    );
}

export default App;
